module.exports = __webpack_public_path__ + "img/chest.8e4d99ea.gif";